
import ProfileHeader from "@/components/ProfileHeader.vue";

export default {
  name: "default",
  components: {
    ProfileHeader,
  },
  computed: {
    isMobile() {
      return this.isClient && window.innerWidth <= 768; // Specify the desired device width threshold
    },
    isClient() {
      return process.client; // Check if code is running on the client-side
    },
  }
}
